import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SpotPageDetails } from 'src/app/interfaces/common/spot.interface';

interface QueryParams {
  searchQuery: string | null;
  categories: string | null;
  types: string | null;
  divisions: string | null;
  area: string | null;
  zone: string | null;
  bodyTypes: string | null;
  hairColors: string | null;
  intimateHairs: string | null;
  height: string | null;
  weight: string | null;
  age: string | null;
  isGoingOut: boolean | null;
  ownPlace: boolean | null;
  acceptsHandicapped: boolean | null;
  verified: boolean | null;
}

@Component({
  selector: 'app-spot-search-area',
  templateUrl: './spot-search-area.component.html',
  styleUrls: ['./spot-search-area.component.scss'],
})
export class SpotSearchAreaComponent {
  @Input() pageData!: SpotPageDetails;

  constructor(private router: Router) {}
  // TODO: Infer a better type
  onSubmitEmitCatch({ formData, inputVal }: { formData: any; inputVal: any }) {
    const queryParams: QueryParams = {
      searchQuery: null,
      categories: formData.category,
      types: formData.type,
      divisions: formData.location,
      area: formData.area,
      zone: formData.zone,
      bodyTypes: formData.bodytype,
      hairColors: formData.hairColor,
      intimateHairs: formData.intimateHairs,
      height: null,
      weight: null,
      age: null,
      isGoingOut: null,
      ownPlace: null,
      acceptsHandicapped: null,
      verified: null,
    };
    if (
      formData.height &&
      (formData.height.minHeight !== 140 || formData.height.maxHeight !== 220)
    ) {
      queryParams['height'] =
        `${formData.height.minHeight}-${formData.height.maxHeight}`;
    }

    if (
      formData.weight &&
      (formData.weight.minWeight !== 40 || formData.weight.maxWeight !== 300)
    ) {
      queryParams['weight'] =
        `${formData.weight.minWeight}-${formData.weight.maxWeight}`;
    }

    if (
      formData.age &&
      (formData.age.minAge !== 18 || formData.age.maxAge !== 80)
    ) {
      queryParams['age'] = `${formData.age.minAge}-${formData.age.maxAge}`;
    }
    if (formData.isGoingOut) {
      queryParams['isGoingOut'] = true;
    }

    if (formData.ownPlace) {
      queryParams['ownPlace'] = true;
    }

    if (formData.acceptsHandicapped) {
      queryParams['acceptsHandicapped'] = true;
    }

    if (formData.verified) {
      queryParams['verified'] = true;
    }

    if (inputVal) {
      queryParams['searchQuery'] = inputVal?.trim();
    }

    this.router.navigate(['/ads'], {
      queryParams,
      queryParamsHandling: 'merge',
    });
  }
}
